module.exports = __webpack_public_path__ + "img/n2.d95c606c.png";